import React from 'react';
import {connect} from 'react-redux';
import * as s from './selectors';
import * as a from './actions';
import * as r from 'ramda';
import './reducers';
import {ConfirmationDialog} from '../../components/confirmation-dialog/views';
import {AlertDialog} from '../../components/alert-dialog/views';

const ProductConfig = connect(
    (state, {id}) => ({
        config: s.productConfig(state, id),
    }),
    (dispatch, {id}) => ({
        add: () => {
            dispatch(a.addProductConfig(id));
        },
        remove: () => {
            dispatch(a.removeProductConfig(id));
        },
    })
)(({config, add, remove}) => {
    return (
        <div className="product-option__item">
            <div className="product-option__value">{config.name}</div>
            <button
                style={{visibility: config.lessAllowed ? 'visible' : 'hidden'}}
                type="button"
                onClick={remove}
                data-cart-count="cartPlus"
                className="btn btn--cart-edit"
            >
                -
            </button>
            {config.count}
            <button
                style={{visibility: config.moreAllowed ? 'visible' : 'hidden'}}
                type="button"
                onClick={add}
                data-cart-count="cartPlus"
                className="btn btn--cart-edit"
            >
                +
            </button>
        </div>
    );
});

const CategoryButton = connect(
    (state, {id}) => ({
        config: s.categoryConfig(state, id),
    }),
    (dispatch, {id}) => ({
        toggle: e => {
            dispatch(a.toggleCategory(id));
        },
    })
)(({config, order, toggle, disabled}) => {
    return (
        <button
            type="button"
            className="btn btn--more"
            onClick={toggle}
            disabled={disabled}
        >
            <span className="btn__label">{config.name}</span>
            <svg width="24" height="24" className="btn__icon">
                <use xlinkHref="#ic_arrow_down" />
            </svg>
        </button>
    );
});

function categoryClass(category) {
    if (!category.enabled) {
        return 'product-option--fade';
    }

    if (category.hasError) {
        return 'product-option--active';
    }

    switch (category.state) {
        case 'unrolled':
            return 'product-option--active';
        case 'selected':
            return 'product-option--valid';
        default:
            return '';
    }
}

const Category = connect((state, {id}) => ({
    category: s.categoryConfig(state, id),
}))(({category, order, toggle}) => {
    return (
        <div className={`product-option ${categoryClass(category)}`}>
            <CategoryButton
                id={category.id}
                order={order}
                disabled={!category.enabled}
            />
            {category.unrolled && (
                <div className="product-option__detail">
                    {r
                        .values(category.productConfigIds)
                        .map(pc => <ProductConfig key={pc} id={pc} />)}
                </div>
            )}
        </div>
    );
});

const TypeSelector = connect(
    (state, ownProps) => ({
        variants: s.variants(state),
    }),
    (dispatch, ownProps) => ({
        select: id => {
            return () => {
                dispatch(a.selectVariant(id));
            };
        },
    })
)(({variants, select}) => {
    return r.map(variant => {
        return (
            <div
                key={variant.id}
                className={`product-option ${
                    variant.selected ? 'product-option--valid' : ''
                } product-option--half`}
            >
                <button
                    type="button"
                    onClick={select(variant.id)}
                    className="btn btn--more"
                >
                    <span className="btn__label">{variant.name}</span>
                </button>
            </div>
        );
    }, variants);
});

const Form = connect((state, ownProps) => ({fields: s.formFields(state)}))(
    ({fields}) => {
        return r.map(([name, value]) => {
            return <input key={name} type="hidden" name={name} value={value} />;
        }, fields);
    }
);

const ProductName = connect(
    (state, ownProps) => ({
        namedProduct: s.namedProduct(state),
    }),
    (dispatch, ownProps) => ({
        nameProduct: () => {
            dispatch(a.nameProduct());
        },
    })
)(({nameProduct, namedProduct}) => {
    const classNames = r.filter(r.complement(r.isEmpty), [
        'product-option',
        'product-option--save',
        namedProduct.savedName ? 'product-option--valid' : '',
    ]);

    return (
        <div className={r.join(' ', classNames)}>
            <button
                type="button"
                className="btn btn--more"
                onClick={nameProduct}
            >
                {namedProduct.label}
                <svg width={24} height={24} className="btn__icon">
                    <use xlinkHref="#ic_arrow_down" />
                </svg>
            </button>
        </div>
    );
});

function VariantDowngradeInvalidAlertBody({title}) {
    return (
        <p>
            <strong>{title}</strong>
        </p>
    );
}

const VairiantDowngradeInvalidAlert = connect(
    (state, ownProps) => ({
        showVariantDowngradeInvalid: s.showVariantDowngradeInvalid(state),
        texts: s.variantDowngradeInvalidAlertTexts(state),
    }),
    (dispatch, ownProps) => ({
        confirm: () => dispatch(a.hideVariantDowngradeInvalid()),
    })
)(({showVariantDowngradeInvalid, cancel, confirm, texts}) => {
    return showVariantDowngradeInvalid ? (
        <AlertDialog
            message={
                <VariantDowngradeInvalidAlertBody title={texts.title}/>
            }
            confirmLabel={texts.confirm}
            onConfirm={confirm}
        />
    ) : null;
});

function SwitchToUnlimitedVariantConfirmationBody({title, body}) {
    return (
        <React.Fragment>
            <p>
                <strong>{title}</strong>
            </p>
            <p>{body}</p>
        </React.Fragment>
    );
}

const VairiantUpgradeDialog = connect(
    (state, ownProps) => ({
        showVariantUpgrade: s.showVariantUpgrade(state),
        texts: s.variantUpgradeDialogTexts(state),
    }),
    (dispatch, ownProps) => ({
        cancel: () => dispatch(a.cancelUpgradingVariant()),
        confirm: () => dispatch(a.upgradeVariant()),
    })
)(({showVariantUpgrade, cancel, confirm, texts}) => {
    return showVariantUpgrade ? (
        <ConfirmationDialog
            message={
                <SwitchToUnlimitedVariantConfirmationBody
                    title={texts.title}
                    body={texts.body}
                />
            }
            confirmLabel={texts.confirm}
            cancelLabel={texts.cancel}
            onCancel={cancel}
            onConfirm={confirm}
        />
    ) : null;
});

function ConfigurationLimitExceededAlertBody({title}) {
    return (
        <p>
            <strong>{title}</strong>
        </p>
    );
}

const ConfigurationLimitExceededDialog = connect(
    (state, ownProps) => ({
        showConfigurationLimitExceeded: s.showConfigurationLimitExceeded(state),
        texts: s.ConfigurationLimitExceededDialogTexts(state),
    }),
    (dispatch, ownProps) => ({
        confirm: () => dispatch(a.hideConfigurationLimitExceeded()),
    })
)(({showConfigurationLimitExceeded, confirm, texts}) => {
    return showConfigurationLimitExceeded ? (
        <AlertDialog
            message={
                <ConfigurationLimitExceededAlertBody title={texts.title} />
            }
            confirmLabel={texts.confirm}
            onConfirm={confirm}
        />
    ) : null;
});

export const ProductConfigurator = connect((state, ownProps) => ({
    categories: s.categoryConfigs(state),
}))(({categories}) => {
    return (
        <div className="product-config">
            <VairiantUpgradeDialog />
            <VairiantDowngradeInvalidAlert />
            <ConfigurationLimitExceededDialog />
            <div className="product-config__form">
                <div className="product-config__header">
                    <TypeSelector />
                </div>
                {r.addIndex(r.map)(
                    (category, n) => (
                        <Category
                            key={category.id}
                            id={category.id}
                            order={n + 1}
                        />
                    ),
                    categories
                )}
                <ProductName />
            </div>
            <Form />
        </div>
    );
});
